<script lang="ts">
  import Loading from '../../etc/loader.svelte';
  import ModifyPlanChangeModal from '../../etc/modal/ModifyPlanChangeModal.svelte';
  import ModifyStopResumeModal from '../../etc/modal/ModifyStopResumeModal.svelte';
  import { getContext } from 'svelte';
  import RepositoryFactory, { CONTRACT, SIM_EXCHANGE_DELIVERY } from '../../repositories/RepositoryFactory';
  import type { GetContractResult } from '../../repositories/contract';
  import { loginUser } from '../../components/auth/LoginUser';
  import { push } from 'svelte-spa-router';
  import { isAvailableStopResumeRequest } from '../../components/Util.svelte';

  const { open }: any = getContext('simple-modal');

  const showModifyPlanChangeModal = () => {
    open(ModifyPlanChangeModal);
  };
  const showModifyStopResumeModal = () => {
    open(ModifyStopResumeModal);
  };

  let promise = getApi();
  let simDeliveryStatusCode = '';
  $: disabledStopResumeRequest = isAvailableStopResumeRequest(simDeliveryStatusCode);

  async function getApi() {
    let contract: GetContractResult;
    const contractRepository = RepositoryFactory[CONTRACT];
    const simRepository = RepositoryFactory[SIM_EXCHANGE_DELIVERY];
    await Promise.all([contractRepository.getContract(), simRepository.getSimExchangeDeliveryStatus()])
      .then((res) => {
        if (!res) {
          throw new Error();
        }
        contract = res[0];
        simDeliveryStatusCode = res[1]?.simDeliveryStatusCode;
      })
      .catch((error) => {
        if (error.response.status === 403) {
          alert('セッションが切れました。再度ログインしてください。');
          loginUser.logout();
          push('/login');
          return false;
        } else {
          alert('エラーが発生しました。');
          throw new Error();
        }
      });
    return contract;
  }

  const isDisabledPlanChange = (contract: GetContractResult): boolean => {
    if (isTerminated(contract)) {
      return true;
    }
    // COM-5205
    // UmobileMaxからの移管した音声プランは変更プランが存在しないため、プラン変更はできないように制御
    if (contract.serviceCode === 'UM_VOICE_25G_MAX') {
      return true;
    }
    return false;
  };

  const isTerminated = (contract: GetContractResult): boolean => {
    return contract.contractStatusCode === 'TERMINATED';
  };
</script>

<!-- 本体 -->
{#await promise}
  <Loading />
{:then contract}
  <div class="flex mb-4">
    <div class="rounded bg-white border-t-4 border-green-400 w-11/12">
      <div class="shadow rounded-lg bg-gray-50 border-1 p-4 mb-10">
        <div class="flex flex-col divide-y divide-gray-300">
          <div class="flex-1 flex flex-col divide-y divide-gray-300 p-4">
            <div class="flex-1">
              <h4 class="text-lg font-semibold">プラン変更</h4>
            </div>
            <div class="flex-1">
              <div class="inline-grid md:grid-cols-3 justify-items-center items-center min-w-full p-4">
                <div class="grid-1 col-span-2 justify-self-start w-full">
                  <span> 契約プラン変更の手続きはこちら </span>
                </div>

                <div class="grid-1">
                  <button
                    on:click={showModifyPlanChangeModal}
                    class="button-primary"
                    disabled={isDisabledPlanChange(contract)}
                  >
                    手続きへ
                  </button>
                </div>
              </div>
            </div>
          </div>

          <div class="flex-1 flex flex-col pt-20 divide-y divide-gray-300 p-4">
            <div class="flex-1">
              <h4 class="text-lg font-semibold">一時停止・再開</h4>
            </div>
            <div class="flex-1">
              <div class="inline-grid md:grid-cols-3 justify-items-center items-center min-w-full p-4">
                <div class="grid-1 col-span-2 justify-self-start w-full">
                  <span class="">SIM一時停止・再開変更の手続きはこちら</span>
                </div>

                <div class="grid-1">
                  <button
                    on:click={showModifyStopResumeModal}
                    class="button-primary"
                    disabled={isTerminated(contract) || disabledStopResumeRequest}
                  >
                    手続きへ
                  </button>
                </div>
              </div>
            </div>
          </div>

          <div class="flex-1 flex flex-col pt-20 divide-y divide-gray-300 p-4">
            <div class="flex-1">
              <h4 class="text-lg font-semibold">SIM交換</h4>
            </div>
            <div class="flex-1">
              <div class="inline-grid md:grid-cols-3 justify-items-center items-center min-w-full p-4">
                <div class="grid-1 col-span-2 justify-self-start w-full">
                  <span class="">SIM交換の手続きはこちら</span>
                </div>

                <div class="grid-1">
                  <button
                    on:click={() => push(`/sim-exchange-delivery/history/`)}
                    class="button-primary"
                    disabled={contract.serviceClass === 'DATA_PLAN' || isTerminated(contract)}
                  >
                    手続きへ
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
{/await}

<style lang="postcss">
  .button-primary {
    @apply bg-green-400 rounded-lg hover:bg-green-500 focus:outline-none text-sm font-semibold text-white px-10 py-2;
  }
  .button-primary:disabled {
    @apply opacity-30 cursor-default bg-gray-400;
  }
</style>
